export const TarifPlansData = [
  {
    id: 'micro',
    title: 'Micro',
    price: 4,
    styleAccess: 'basic',
    coins: 600,
    features: [
      '5 greeting cards',
      'Edits - 1 pc',
      'Greeting texts 5 with 5 ideas each',
      'Basic greeting calendar'
    ],
    term: 'Valid for 3 months',
    highlighted: false
  },
  {
    id: 'mini',
    title: 'Mini',
    price: 8,
    styleAccess: 'basic',
    coins: 1300,
    features: [
      '10 greeting cards',
      'Edits - 3 pcs',
      'Greeting texts 15 with 5 ideas each',
      'Basic greeting calendar'
    ],
    term: 'Valid for 6 months',
    highlighted: false
  },
  {
    id: 'yearly',
    title: 'Yearly',
    price: 18,
    styleAccess: 'extended',
    coins: 4000,
    badge: 'Popular',
    features: [
      '30 greeting cards',
      'Edits - 10 pcs',
      'Greeting texts 50 with 5 ideas each',
      'Extended greeting calendar'
    ],
    term: 'Valid for 12 months',
    highlighted: true
  },
  {
    id: 'pryvitanator',
    title: 'Greeter',
    price: 46,
    styleAccess: 'extended',
    coins: 12700,
    features: [
      '100 greeting cards',
      'Edits - 30 pcs',
      'Greeting texts 120 with 5 ideas each',
      'Extended greeting calendar'
    ],
    term: 'Valid for 12 months',
    highlighted: false
  },
  {
    id: 'generator',
    title: 'Generator',
    price: 94,
    styleAccess: 'extended',
    coins: 38000,
    features: [
      '300 greeting cards',
      'Edits - 100 pcs',
      'Greeting texts 350 with 5 ideas each',
      'Extended greeting calendar'
    ],
    term: 'Valid for 24 months',
    highlighted: false
  },
];